import { render, staticRenderFns } from "./fromTo.vue?vue&type=template&id=9b621562&"
import script from "./fromTo.vue?vue&type=script&lang=js&"
export * from "./fromTo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports